(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/poll.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/poll.js');

'use strict';

const {
  Events: AuthenticateEvents,
  TimeoutTypes
} = svs.accountservices.authenticate.definitions;
svs.player_login.views.bankid.Poll = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.bankid_poll(data);
  },
  templateContext() {
    svs.utils.url.refreshQueryString();
    return {
      viewData: {
        isSsnFallback: svs.core.detect.formfactor.mobile() && svs.utils.url.queryString.ltt === TimeoutTypes.BANKID_SSN
      }
    };
  },
  ui: {
    loader: '.js-loader-container',
    openBankId: '.js-open-bankid'
  },
  events: {
    'click @ui.openBankId': 'onOpenBankIdClick'
  },
  behaviors: [svs.player_login.behaviors.About, svs.player_login.behaviors.Login, svs.player_login.behaviors.Navigation],
  initialize() {
    delete this.loader;
  },
  onError() {
    if (svs.core.detect.formfactor.mobile()) {
      this.triggerMethod('do:navigation', '/');
    } else {
      this.triggerMethod('do:navigation', '/bankid');
    }
  },
  onBeforeError() {
    if (this.loader) {
      this.loader.hide();
    }
  },
  onOpenBankIdClick(e) {
    e.preventDefault();
    svs.utils.url.navigate(svs.accountservices.authenticate.login.getAppUrl());
  },
  onAttach() {
    const isPnpMobile = this.model.get('isPnpMobile');
    this.loader = new svs.ui.Loader(this.getUI('loader'));
    this.loader.show(300, isPnpMobile ? '' : 'inverted');
    if (svs.accountservices.authenticate.login.isStarted()) {
      if (!svs.accountservices.authenticate.login.startedWithSsn()) {
        if (!svs.player_login.utils.dontTryNavigationAppUrl) {
          svs.utils.url.navigate(svs.accountservices.authenticate.login.getAppUrl());
        }
      }
      svs.accountservices.authenticate.login.poll();
    } else {
      svs.accountservices.authenticate.login.on(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll, this);
      svs.accountservices.authenticate.login.on(AuthenticateEvents.NO_RESUME, this.onNoResume, this);
      svs.accountservices.authenticate.login.resumePendingLogin();
    }
  },
  onNoResume() {
    setTimeout(() => this.triggerMethod('do:navigation', '/bankid'), 30);
  },
  onReadyToPoll() {
    svs.accountservices.authenticate.login.poll();
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll);
    svs.accountservices.authenticate.login.off(AuthenticateEvents.NO_RESUME, this.onNoResume);
    svs.accountservices.authenticate.login.cancel();
  }
});

 })(window);